import { AgTechBadge } from '@agtech/web/components/Badges/AgTechBadge';
import { SaleLot, getLotStatus, isLotInvoiced } from '@sales/data/lots/LotData';
import React from 'react'

export type LotStatusBadgeProps = {
    lot: SaleLot,
    classes?: string
}

const LotStatusBadge = (props: LotStatusBadgeProps) => {
    const lot = props.lot;
    const badgeText = getLotStatus(lot);

    const badgeColor = isLotInvoiced(lot) ? 'color-highlight'
        : badgeText === 'Sold' ? 'color-green'
        : 'bg-slate-100';

    return (
        <AgTechBadge
            text={badgeText}
            classes={`${badgeColor} !text-sm ${props.classes ?? ''}`}
        />
    )
}

export default LotStatusBadge